module.exports = __webpack_public_path__ + "img/slider-fast-trading.cefb493.png";